module.exports = __webpack_public_path__ + "750aee391c6ae036591f5c94360e65a5.ttf";